import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Users, Building, FileText } from "lucide-react";

export default function CallToAction() {
  return (
    <section id="call-to-action" className="bg-gradient-to-r from-primary-800 to-primary-700 relative overflow-hidden">
      {/* Background Patterns */}
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-10">
        <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <pattern id="dots" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
              <circle fill="white" cx="5" cy="5" r="1" />
            </pattern>
          </defs>
          <rect x="0" y="0" width="100%" height="100%" fill="url(#dots)" />
        </svg>
      </div>
      
      <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:py-20 lg:px-8 relative z-10">
        <div className="lg:grid lg:grid-cols-2 lg:gap-12 items-center">
          <div>
            <div className="inline-flex items-center px-4 py-2 rounded-md text-base font-bold bg-primary-100 text-primary-800 mb-4 shadow-md border-2 border-primary-200 uppercase tracking-wide">
              White Paper Available Now
            </div>
            <h2 className="text-3xl font-extrabold tracking-tight sm:text-4xl mb-6 leading-tight">
              <span className="block mb-1 text-primary-900 bg-white px-2 py-1 rounded-md inline-block shadow-sm">Join us in transforming</span>
              <span className="block mt-1 text-primary-900 bg-white px-2 py-1 rounded-md inline-block shadow-sm">justice through opportunity.</span>
            </h2>
            <p className="text-primary-900 bg-white/95 px-3 py-2 rounded-md text-lg mb-8 shadow-sm">
              The StaffAbility concept paper proposes a bold vision for justice reform through skills training, 
              career development, and long-term support. We're seeking partners, advisors, and supporters to 
              help refine and ultimately implement this innovative model.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
              <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm">
                <div className="flex items-center mb-3">
                  <div className="bg-primary-100 p-2 rounded-md mr-3">
                    <Users className="h-5 w-5 text-primary-700" />
                  </div>
                  <h3 className="font-semibold text-primary-900 bg-white px-2 py-1 rounded-md shadow-sm">For Advocates</h3>
                </div>
                <p className="text-primary-900 bg-white/95 px-2 py-1 rounded-md text-sm shadow-sm">
                  Join our advisory board and help shape the staffability approach to skills development and support.
                </p>
              </div>
              
              <div className="bg-white/10 p-4 rounded-lg backdrop-blur-sm">
                <div className="flex items-center mb-3">
                  <div className="bg-primary-100 p-2 rounded-md mr-3">
                    <Building className="h-5 w-5 text-primary-700" />
                  </div>
                  <h3 className="font-semibold text-primary-900 bg-white px-2 py-1 rounded-md shadow-sm">For Employers</h3>
                </div>
                <p className="text-primary-900 bg-white/95 px-2 py-1 rounded-md text-sm shadow-sm">
                  Become a founding employer partner in our ecosystem of second-chance employment opportunities.
                </p>
              </div>
            </div>
          </div>
          
          <div className="mt-10 lg:mt-0 flex flex-col gap-6 items-center justify-center lg:items-start">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6 w-full max-w-md">
              <h3 className="text-xl font-semibold text-primary-900 bg-white px-2 py-1 rounded-md shadow-sm mb-4">Stay Informed</h3>
              <p className="text-primary-900 bg-white/95 px-2 py-1 rounded-md shadow-sm mb-6">
                Join our mailing list to receive updates on the StaffAbility concept development, white paper releases, and partnership opportunities.
              </p>
              
              <div className="space-y-4">
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  className="w-full px-4 py-2 rounded-md bg-white border border-gray-300 text-black placeholder:text-gray-500"
                  disabled
                />
                <div className="grid grid-cols-2 gap-4">
                  <Button variant="secondary" className="w-full" disabled>
                    Subscribe
                  </Button>
                  <Button asChild className="w-full">
                    <Link href="/get-involved">
                      Learn More
                    </Link>
                  </Button>
                </div>
                <a 
                  href="https://drive.google.com/file/d/1FB4e2OVsvXjox6g4-tFB8YZZledqvrp2/view?usp=sharing" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-xs text-primary-900 bg-white/95 px-2 py-1 rounded-md shadow-sm text-center block hover:bg-primary-50 transition-colors"
                >
                  <FileText className="inline h-3 w-3 mr-1 text-primary-700" />
                  <span>Download White Paper & Impact Report 2.0</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
